import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {
	IVariable,
	VariableListTypes,
	variablesList
} from '@models/system-variables/variables-to-insert';

@Component({
	selector: 'insert-variable',
	template: require('./insert-variable.component.html')
})
export class InsertVariableComponent implements OnInit {
	@Input() variableListType: VariableListTypes;
	@Output() onVariableChoose: EventEmitter<string> = new EventEmitter();

	variableList: Array<IVariable> = [];
	openState: boolean;

	constructor() {}

	ngOnInit(): void {
		this.createVariableList();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			!changes.variableListType.isFirstChange() &&
			changes.variableListType.currentValue
		) {
			this.createVariableList();
		}
	}

	chooseVariable(variable: string): void {
		this.toggleList(false);
		this.onVariableChoose.emit(variable);
	}

	toggleList(state?: boolean): void {
		if (typeof state === 'boolean') {
			this.openState = state;
			return;
		}
		this.openState = !this.openState;
	}

	private createVariableList(): void {
		this.variableList = Object.keys(variablesList[this.variableListType]).map(
			(key: string): IVariable => ({
				key: variablesList[this.variableListType][key],
				name: key
			})
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/components/common/buttons/insert-variable/insert-variable.component.ts